__webpack_require__.p = "https://static.age.awaze.com/search-mfe/fd552b3/_next/";